import { customerList } from "constants/customer";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addCustomer = async (bodyData) => {
  try {
    const res = await API.add_customer(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getCustomerList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.customer_list(pageNum, filters);
    dispatch({ type: customerList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: customerList,
      payload: error?.response?.data || error,
    });
  }
};

export const getCustomerById = async (id) => {
  try {
    const res = await API.get_customer_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateCustomerById = async (id, bodyData) => {
  try {
    const res = await API.edit_customer(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteCustomerById = async (id) => {
  try {
    const res = await API.delete_customer_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}